import { getDocument } from "./auth-service-tools627.js";

function getActiveElement(element) {
  var _getDocument = getDocument(element),
      activeElement = _getDocument.activeElement;

  if (!(activeElement !== null && activeElement !== void 0 && activeElement.nodeName)) {
    return null;
  }

  return activeElement;
}

export { getActiveElement };